import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Layout,
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Breadcrumb,
  Space,
} from "antd";

import { useBackend } from "backend/useBackend";

const { Content } = Layout;

const endpoint = "topics";

const Add = () => {
  const navigate = useNavigate();

  const { addItem } = useBackend()

  const onFinish = values => {
    const payload = {
      ...values,
    }
    // console.log(payload)
    addItem(endpoint, payload, {
      redirectTo: endpoint,
      loader: true,
      msg: {
        loading: 'Adding...',
        success: 'Author Added'
      }
    })
  }

  const onFinishFailed = data => console.log(data)

  return (
    <Content>
      <Breadcrumb>
        <Breadcrumb.Item>Topics</Breadcrumb.Item>
        <Breadcrumb.Item>Add</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col md={12}>
          <Card title="Add Details">
          <Form
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              size={"large"}
            >
              <Row gutter={24}>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Name"
                    name="name"
                    rules={[
                      { required: true, message: "Name is required" },
                    ]}
                  >
                    <Input placeholder="Name" />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Slug"
                    name="slug"
                    rules={[
                      { required: true, message: "Slug is required" },
                    ]}
                    size={"large"}
                  >
                    <Input placeholder="Slug" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                className="mb-2"
                label="Description"
                name="description"
                rules={[{ required: true, message: "Description is required" }]}
                size={"large"}
              >
                <Input.TextArea placeholder="Description" />
              </Form.Item>
              <Form.Item>
                <Row justify="end" style={{ marginTop: "2em" }}>
                  <Col>
                    <Space size="small">
                      <Button type="primary" htmlType="submit" size="large">
                        Add
                      </Button>
                      <Button
                        type="primary"
                        ghost
                        size="large"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default Add;
